<template>
  <sf-dialog v-model="dialog">
    <template #activator="slotData">
      <slot name="activator" v-bind="slotData" />
    </template>
    <v-card>
      <v-card-item>
        <v-card-title>
          <sf-heading>{{ title }}</sf-heading>
        </v-card-title>
      </v-card-item>
      <v-card-text class="text-justify">
        <sf-text>{{ description }}</sf-text>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <sf-text-button color="grey" class="text-medium-emphasis" @click="close">
          {{ $t('cancel') }}
        </sf-text-button>
        <sf-text-button color="error" :loading="loading" @click="$emit('confirm')">
          {{ $t('delete') }}
        </sf-text-button>
      </v-card-actions>
    </v-card>
  </sf-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SfTextButton from '@/components/button/SfTextButton.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import SfText from '@/components/text/SfText.vue'
import SfDialog from '@/components/dialog/SfDialog.vue'

defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
})

defineEmits(['confirm'])
const dialog = ref(false)

const close = () => {
  dialog.value = false
}
</script>
